import ButtonGroup from 'react-bootstrap/ButtonGroup';
import ToggleButton from 'react-bootstrap/ToggleButton';

export default function ActiveWorkerToggleGroup({
                                                    activeWorkerId,
                                                    setActiveWorkerId,
                                                    workerStatusCount,
                                                    fieldWorkerMap,
                                                    fieldWorkerArray
                                                }) {
    return (
        <div>


            <ButtonGroup style={{display: "flex", flexWrap: "wrap"}}>
                {fieldWorkerArray.filter((worker) => worker.isDeleted != true).map((radio, idx) => (
                    <ToggleButton
                        className="rounded-pill"
                        key={idx}
                        id={`workerradio-${idx}`}
                        type="radio"
                        variant="outline-secondary"
                        name="radio1"
                        value={radio.id}
                        checked={(activeWorkerId + '') === (radio.id + '')}
                        onChange={(e) => setActiveWorkerId(e.currentTarget.value)}
                    >
                        {workerStatusCount[radio.id] ?
                            <div>{radio.name}<span style={{color: "blue"}}>{ ' (' + workerStatusCount[radio.id] + ') '}</span></div> :
                            radio.name + '    '}
                    </ToggleButton>
                ))}
            </ButtonGroup>
        </div>
    );
}
